import React from "react";
import './style.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import LogoFooter from '../../assets/img/logo/Save-Logo-White-Long.png';

export default function Footer() {
  return (
    <div>
      <footer>
        <div className="container py-4 pt-5">
          <div className="d-flex flex-lg-row flex-column 
            justify-content-lg-between align-items-center align-items-lg-start">

            {/* 🔹 Left Column — Logo + Tagline */}
            <div className="col-10 col-lg-3 
              d-flex flex-column text-center text-lg-start mb-3">
              <div className="mb-3 px-3 px-lg-0">
                <img src={LogoFooter} className="d-block w-100" alt="SAVE Logo" />
              </div>                
              <div className="mb-2 fs-5 fw-semibold">Securing Your Digital Assets</div>              
              <div className="small text-secondary">
                Powered by <span className="fw-bold text-light">CyberSecOps Private Limited</span>
              </div>
            </div>

            {/* 🔹 Middle Column — Address */}
            <div className="col-12 col-lg-4 text-center text-lg-start mb-3">
              <div className="mb-3 fw-bold fs-5">Address</div>
              <div className="mb-1 pe-0 pe-lg-5">DN-36, Primarc Tower, Unit No. 1103,</div>              
              <div className="mb-1 pe-0 pe-lg-5">DN Block, Sector V, Bidhannagar,</div>
              <div className="mb-3 pe-0 pe-lg-5">Kolkata, West Bengal - 700091</div>
              <div className="mb-2">
                <a href="mailto:info@vulnerabilityassesmenttool.com" className="footer-link">
                  info@vulnerabilityassesmenttool.com
                </a>
              </div>
              <div>
                <a href="tel:+919147380653" className="footer-link">+91-91473-80653</a>
              </div>
            </div>

            {/* 🔹 Right Column — Quick Links */}
            <div className="col-10 col-lg-1 d-flex flex-column text-center text-lg-end mb-3">
              {/* <a href="https://vulnerabilityassesmenttool.com/faq" target="_blank" rel="noopener noreferrer">FAQs</a> */}
              {/* <a href="https://vulnerabilityassesmenttool.com/blog" target="_blank" rel="noopener noreferrer">Blog</a> */}
              <a href="/about-us" target="_blank" rel="noopener noreferrer">About Us</a>
              <a href="/contact-us" target="_blank" rel="noopener noreferrer">Contact Us</a>
            </div>
          </div>

          {/* 🔹 Bottom Section — Social + Copyright + Legal */}
          <div className="d-flex flex-lg-row flex-column 
            align-items-center align-items-lg-start justify-content-between mt-3 border-top pt-3">

            {/* Social Icons */}
            <div className="col-10 col-lg-4 text-center text-lg-start mb-2">
              <a href="https://www.linkedin.com/company/indian-cyber-security-solutions" target="_blank" rel="noopener noreferrer" className="me-3 text-light">
                <i className="bi bi-linkedin fs-5"></i>
              </a>
              <a href="https://www.youtube.com/@SAVE.Securities" target="_blank" rel="noopener noreferrer" className="me-3 text-light">
                <i className="bi bi-youtube fs-5"></i>
              </a>
              {/* <a href="https://facebook.com/" target="_blank" rel="noopener noreferrer" className="text-light">
                <i className="bi bi-facebook fs-5"></i>
              </a> */}
            </div>

            {/* Copyright */}
            <div className="col-12 col-lg-4 text-center mb-2">
              <p className="mb-0">
                © {new Date().getFullYear()} SAVE. All rights reserved.
              </p>
            </div>

            {/* Legal Links — side by side */}
            <div className="col-12 col-lg-4 text-center text-lg-end mb-2 d-flex flex-wrap justify-content-center justify-content-lg-end gap-3">
              <a href="https://vulnerabilityassesmenttool.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="footer-link">
                Privacy Policy
              </a>
              <a href="https://vulnerabilityassesmenttool.com/terms-and-conditions" target="_blank" rel="noopener noreferrer" className="footer-link">
                Terms & Conditions
              </a>
              <a href="https://vulnerabilityassesmenttool.com/refund-policy" target="_blank" rel="noopener noreferrer" className="footer-link">
                Refund Policy
              </a>
              <a href="https://vulnerabilityassesmenttool.com/shipping" target="_blank" rel="noopener noreferrer" className="footer-link">
                Shipping
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
